import { forwardRef, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { usePortalContainer } from './hooks/usePortalContainer.js';
import { setRef } from './utils.js';

var Portal = forwardRef(function (props, ref) {
    var portalContainer = usePortalContainer();
    var _a = props.getPortalContainer, getPortalContainer = _a === void 0 ? portalContainer : _a, _b = props.immediateMount, immediateMount = _b === void 0 ? false : _b, children = props.children;
    var _c = useState(function () {
        return typeof window !== 'undefined' && immediateMount ? getPortalContainer() : null;
    }), mountNode = _c[0], setMountNode = _c[1];
    useEffect(function () {
        setMountNode(getPortalContainer());
    }, [getPortalContainer]);
    useEffect(function () {
        if (mountNode) {
            setRef(ref, mountNode);
            return function () {
                setRef(ref, null);
            };
        }
        return function () { return null; };
    }, [ref, mountNode]);
    return mountNode ? createPortal(children, mountNode) : mountNode;
});
Portal.displayName = 'Portal';

export { Portal };
